module.exports = __webpack_public_path__ + "static/media/7fe28c1d-e2f7-4b1f-8a53-5da8f54502f0.78223ec3.JPG";